import React from "react";
import { useSelector } from "react-redux";
import spinnerLogo from "../Spinner.png";

const CenterSpinner = () => {
  const { pendingPage } = useSelector((state) => ({
    ...state.navigationReducer,
  }));

  return (
    <img
      src={spinnerLogo}
      alt=""
      className={`spinner ${pendingPage ? "spinning" : ""}`}
    />
  );
};

export default CenterSpinner;
